/**
 * FAQ data specifically for the Sick Note page
 * Each FAQ has a unique ID, question, answer, and optional properties
 */

// Sick Note FAQs based on doctor's content plus your existing FAQs
const faqData = [
  {
    id: 'cost',
    question: 'How much does a sick note cost?',
    answer: "The typical fee is <strong>$65</strong>. If your request is more complex, we'll inform you of the full cost before proceeding."
  },
  {
    id: 'types',
    question: 'What types of sick notes do you provide?',
    answer: 'We issue sick notes for:<ul><li>Work absence</li><li>School absence</li></ul>'
  },
  {
    id: 'complex',
    question: 'I need a more complex sick note. Can the doctor provide a sick note that is different from the sample displayed?',
    answer:
      'No, we only provide sick notes identical to the sample one shown above this notice. If you require a custom form to be filled out, please use the Medical Form service on our website. See Medical Forms under the Services+ tab at the very top of this page for details.'
  },
  {
    id: 'doctor',
    question: 'Will I need to speak with a doctor?',
    answer: 'In some cases, yes. You may be contacted for a <strong>phone or virtual consultation</strong> before your note is issued to ensure it meets medical and legal requirements.'
  },
  {
    id: 'time',
    question: 'How quickly will I receive the note?',
    answer: 'Most notes are issued within <strong>1 business day</strong>, provided all necessary information has been submitted.'
  },
  {
    id: 'validity',
    question: 'Is this service legally valid?',
    answer: 'Yes. All notes are issued by licensed Canadian physicians and are widely accepted by schools and employers across British Columbia.'
  },
  {
    id: 'duration',
    question: 'How long of a sick note can you provide?',
    answer: 'We only provide a maximum of 7 consecutive days for sick notes using our online service. If you need to be off for a longer time you must book an appointment and discuss with a provider.'
  },
  {
    id: 'refund',
    question: 'Are sick notes refundable?',
    answer: 'No, sick notes are not refundable.'
  },
  {
    id: 'security',
    question: 'Is my information protected?',
    answer: "Absolutely. We are fully compliant with <strong>BC's PIPA (Personal Information Protection Act)</strong> and use secure, encrypted platforms.",
    hasBadge: true
  }
];

// Helper function to transform to JSON-LD schema format
export const getFAQSchema = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer.replace(/<\/?[^>]+(>|$)/g, '') // Strip HTML for schema
      }
    }))
  };
};

export default faqData;
